import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { Row, Col } from "reactstrap"
import Select from "react-select"
import { SaveButton } from "components/Buttons"
import {
  getCodesList,
  getEventsBySearch,
  getUsersBySearch,
  hideReassignCodeModal,
  openCreateUserModal,
  reassignCode,
  resetCreatedUser,
} from "store/actions"

const ReassignCodeModal = ({
  code,
  createdUser,
  resetCreatedUser,
  getUsersBySearch,
  getEventsBySearch,
  openCreateUserModal,
  usersBySearch,
  events,
  hideReassignCodeModal,
  loading,
  reassignCode,
  getCodesList,
}) => {
  const [userValue, setUserValue] = useState()
  const [eventValue, setEventValue] = useState()
  const [showErrorMessage, setShowErrorMessage] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  let timeOut = null

  useEffect(() => {
    return () => {
      resetCreatedUser()
    }
  }, [])

  useEffect(() => {
    if (createdUser) {
      setUserValue({
        label: `${createdUser?.first_name} ${createdUser?.last_name} (${createdUser?.email})`,
        value: createdUser?.id,
      })
    }
  }, [createdUser])

  const handleSave = () => {
    if (code?.role === "Guest" && !userValue) {
      setErrorMessage("Please make sure to select or create a new user.")
      setShowErrorMessage(true)
    } else if (code?.role === "Host" && (!eventValue || !userValue)) {
      setErrorMessage(
        "Please make sure to select or create a new user and to select a valid event."
      )
      setShowErrorMessage(true)
    } else {
      setShowErrorMessage(false)
      reassignCode({
        values: {
          code: code?.code,
          event_id: code?.role === "Guest" ? code?.event_id : eventValue?.value,
          type: code?.role?.toLowerCase(),
          user_id: userValue?.value,
        },
        callback: () => {
          getCodesList({
            bch: 0,
            o: "created_at",
            od: "desc",
            page: 1,
          })
        },
      })
    }
  }

  return (
    <React.Fragment>
      {showErrorMessage && (
        <div>
          <Row>
            <Col>
              <span style={{ color: "red" }}>The code can't be assigned.</span>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <span style={{ color: "red" }}>{errorMessage}</span>
            </Col>
          </Row>
        </div>
      )}
      <Row>
        <Col>
          <h6>
            By proceeding, you will re-allocate the code "{code?.code}" to the
            selected user.
          </h6>
        </Col>
      </Row>
      <Row className="mt-1 mb-3">
        <Col>
          <Select
            placeholder="Search for a user"
            options={usersBySearch.map(user => ({
              label: `${user.first_name} ${user.last_name} (${user.email})`,
              value: user.id,
            }))}
            value={userValue}
            onChange={e => setUserValue(e)}
            onInputChange={(value, meta = {}) => {
              if (timeOut) {
                clearTimeout(timeOut)
              }
              timeOut = setTimeout(() => {
                if (meta.action === "input-change") {
                  getUsersBySearch({ t: value })
                }
              }, 300)
            }}
            isClearable={true}
          />
        </Col>
      </Row>
      <Row className="mt-1 mb-3">
        <Col xs="auto">
          <SaveButton
            content="Create User"
            type="button"
            onClick={openCreateUserModal}
          />
        </Col>
      </Row>
      {code?.role === "Host" && (
        <div>
          <Row className="mt-3">
            <Col>
              <h6>Assign the code and user to the following event</h6>
            </Col>
          </Row>
          <Row className="mt-1 mb-3">
            <Col>
              <Select
                placeholder="Search for an event"
                options={events.map(event => ({
                  label: `${event.name} (#${event.id})`,
                  value: event.id,
                }))}
                value={eventValue}
                onChange={e => setEventValue(e)}
                onInputChange={(value, meta = {}) => {
                  if (timeOut) {
                    clearTimeout(timeOut)
                  }
                  timeOut = setTimeout(() => {
                    if (meta.action === "input-change") {
                      getEventsBySearch({ t: value })
                    }
                  }, 300)
                }}
                isClearable={true}
              />
            </Col>
          </Row>
        </div>
      )}
      <Row className="d-flex justify-content-end">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Cancel"
            color="danger"
            onClick={hideReassignCodeModal}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Reassign"
            onClick={handleSave}
            loading={loading}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  usersBySearch: state.SiteUsers.usersBySearch,
  events: state.Communications.events,
  createdUser: state.codes.createdUser,
  loading: state.codes.loading,
})

const mapDispatchToProps = dispatch => ({
  getUsersBySearch: values => dispatch(getUsersBySearch(values)),
  openCreateUserModal: () => dispatch(openCreateUserModal()),
  getEventsBySearch: values => dispatch(getEventsBySearch(values)),
  resetCreatedUser: () => dispatch(resetCreatedUser()),
  hideReassignCodeModal: () => dispatch(hideReassignCodeModal()),
  reassignCode: values => dispatch(reassignCode(values)),
  getCodesList: values => dispatch(getCodesList(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ReassignCodeModal)
